import { defineComponent, h, ref } from 'vue';
import { tooltip } from '@/ui/components/Tooltip';
import { featureExplanationIcon } from '@/ui/components/icon/icons';
import { button } from '@/ui/components';
import { t } from '@/ui/i18n/i18n';
import { ResetKeyConfirmationModal } from '@/ui/components/publicApi/ResetKeyConfirmationModal';
import { useTask } from '@/ui/concerns';
import { resetApiKeys } from '@/services/api/resources/organization/actions';
import { user } from '@/ui/auth/auth';
import { EventBus } from '@/ui/EventBus';
import { Events } from '@/ui/events';

export const PublicApiButtons = defineComponent({
  setup() {
    const isResettingAPIKeys = ref(false);
    const isResetKeyConfirmationModalOpen = ref(false);

    const onModalInput = (value: boolean) => {
      isResetKeyConfirmationModalOpen.value = value;
    };

    const resetKeysTask = useTask(
      () => resetApiKeys(user.value.organization.id),
      () => {
        EventBus.$emit(Events.APIKeysRegenerated);
        isResetKeyConfirmationModalOpen.value = false;
        isResettingAPIKeys.value = false;
      },
      undefined,
      () => {
        isResettingAPIKeys.value = false;
      },
    );

    const onResetAPIKeys = () => {
      isResettingAPIKeys.value = true;
      resetKeysTask.run();
    };

    return function render() {
      return h('div', { class: 'api-keys-index__button-wrapper' }, [
        h(ResetKeyConfirmationModal, {
          props: { active: isResetKeyConfirmationModalOpen.value, loading: isResettingAPIKeys.value },
          on: { input: onModalInput, 'click:resetKeys': onResetAPIKeys },
        }),
        button(t('api-keys.reset-key-button'), () => onModalInput(true)),
        h('div', [
          h('a', { attrs: { href: process.env.VUE_APP_DEVELOPER_URL, target: '_blank' } }, [
            button(
              t('api-keys.api-documentation'),
              () => {},
              undefined,
              { btnClass: 'api-keys-index__api-doc-button' },
            ),
          ]),
          tooltip({
            label: t('api-keys.tooltips.api-documentation'),
            position: 'is-left',
            classes: 'api-keys-index__api-doc-tooltip',
          }, [
            featureExplanationIcon(),
          ]),
        ]),
      ]);
    };
  },
});
